import React, { useState, useEffect } from "react";

const MCQMultiSelect = ({ question, options, onOptionSelect, submitted }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [optionCorrectness, setOptionCorrectness] = useState({});

  useEffect(() => {
    if (submitted) {
      const selected = options.filter(option => selectedOptions.includes(option.options)).map(option => option.options);
      onOptionSelect(selected);

      const correctness = {};
      options.forEach(option => {
        correctness[option.options] = option.correct === 1;
      });
      setOptionCorrectness(correctness);
    }
  }, [submitted, options, selectedOptions, onOptionSelect]); // Correct dependencies

  // Call onOptionSelect whenever selectedOptions changes
  useEffect(() => {
    onOptionSelect(selectedOptions);
  }, [selectedOptions, onOptionSelect]);

  const handleOptionToggle = (option) => {
    const isSelected = selectedOptions.includes(option.options);
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter(item => item !== option.options));
    } else {
      setSelectedOptions([...selectedOptions, option.options]);
    }
  };

  return (
    <div className="max-w-full rounded overflow-hidden shadow-lg mt-4 mx-4 bg-white p-4">
      <p className="font-bold text-lg mb-2">{question}</p>
      <div className="flex flex-col">
        {Array.isArray(options) ? (
          options.map((option, index) => (
            <div key={index} className={`flex items-center mb-2 ${submitted ? (optionCorrectness[option.options] ? 'text-green-600' : 'text-red-600') : ''}`}>
              <input
                type="checkbox"
                id={`option${index}`}
                value={option.options}
                checked={selectedOptions.includes(option.options)}
                onChange={() => handleOptionToggle(option)}
                className="mr-2"
                disabled={submitted} // Disable checkboxes after submission
              />
              <label htmlFor={`option${index}`}>{option.options}</label>
            </div>
          ))
        ) : (
          <p>Options are not available.</p>
        )}
      </div>
    </div>
  );
};

export default MCQMultiSelect;
